export const css = {
	root: '_1sG4AWV5',
	input: '_2jXv49RZ',
	defaultKind: '-l0GyiqM',
	outlinedKind: 'DhjFVHFV',
	disabled: '_3FFoiNag',
	readonly: '_2k5QtWxb',
	invalid: '_3skJEqey',
	valid: 'pXrLF4n2',
	notchedOutlineNotch: '_1Ja-R1rG',
	' _key': 'certwise-theme/dojo/text-area'
};

export default css;
